import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import {
  CheckboxField,
  Modal,
  ModalControlModalProps,
  PrimaryButton,
  SecondaryButton,
  useFormField,
  useModalLoadingState,
} from '@frontend/design-system';
import { TermsAndConditionsBody } from './terms-and-conditions-body';

interface LegalModalProps {
  onAccept: ({ setLoading }: { setLoading: (loading: boolean) => void }) => void;
  modalProps: ModalControlModalProps;
}

const ModalContents = ({ onAccept, modalProps }: LegalModalProps) => {
  const { t } = useTranslation('payments');
  const checkboxFieldProps = useFormField({ type: 'checkbox' });
  const { setLoading } = useModalLoadingState();

  return (
    <>
      <Modal.Header
        css={css`
          margin-bottom: ${theme.spacing(2)};
        `}
      >
        {t('Terms and conditions')}
      </Modal.Header>
      <Modal.Body>
        <TermsAndConditionsBody />
        <span
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: ${theme.spacing(4)};
          `}
        >
          <span
            css={css`
              display: flex;
              max-width: ${theme.spacing(28)};
            `}
          >
            <CheckboxField
              {...checkboxFieldProps}
              name='agrees'
              trackingId='portal-payments_setup-stripe_tos_checkbox'
              label={t('I have read and agree with the Terms and Conditions')}
              css={css`
                align-items: center;
              `}
            />
          </span>
          <span
            css={css`
              display: flex;
              flex-direction: row;
              gap: ${theme.spacing(2)};
            `}
          >
            <PrimaryButton
              onClick={() => onAccept({ setLoading })}
              trackingId='portal-payments_setup-stripe_accept-tos_button'
              css={css`
                width: max-content;
              `}
              disabled={!checkboxFieldProps.value}
            >
              {t('Continue to Stripe')}
            </PrimaryButton>
            <SecondaryButton
              onClick={modalProps.onClose}
              trackingId='portal-payments_setup-stripe-cancel-tos_button'
              css={css`
                width: max-content;
              `}
            >
              {t('Cancel')}
            </SecondaryButton>
          </span>
        </span>
      </Modal.Body>
    </>
  );
};

export const TermsAndConditionsModal = ({ onAccept, modalProps }: LegalModalProps) => (
  <Modal {...modalProps} maxWidth={800}>
    <ModalContents onAccept={onAccept} modalProps={modalProps} />
  </Modal>
);
